"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rect = void 0;

var Factory_1 = require("../Factory");

var Shape_1 = require("../Shape");

var Global_1 = require("../Global");

var Util_1 = require("../Util");

var Validators_1 = require("../Validators");

var Rect = /*#__PURE__*/function (_Shape_1$Shape) {
  _inherits(Rect, _Shape_1$Shape);

  var _super = _createSuper(Rect);

  function Rect() {
    _classCallCheck(this, Rect);

    return _super.apply(this, arguments);
  }

  _createClass(Rect, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var cornerRadius = this.cornerRadius(),
          width = this.width(),
          height = this.height();
      context.beginPath();

      if (!cornerRadius) {
        context.rect(0, 0, width, height);
      } else {
        Util_1.Util.drawRoundedRectPath(context, width, height, cornerRadius);
      }

      context.closePath();
      context.fillStrokeShape(this);
    }
  }]);

  return Rect;
}(Shape_1.Shape);

exports.Rect = Rect;
Rect.prototype.className = 'Rect';
(0, Global_1._registerNode)(Rect);
Factory_1.Factory.addGetterSetter(Rect, 'cornerRadius', 0, (0, Validators_1.getNumberOrArrayOfNumbersValidator)(4));